import { useState } from 'react';
import { Button } from './ui/button';
import { Input } from './ui/input';
import './FolderSidebar.css';

const FolderSidebar = ({ 
  embedded = false,
  folders, 
  selectedFolder, 
  onSelectFolder, 
  onCreateFolder, 
  onUpdateFolder, 
  onDeleteFolder,
  storyCounts,
  favoriteCount,
  isGerman 
}) => {
  const [isCreating, setIsCreating] = useState(false);
  const [newFolderName, setNewFolderName] = useState('');
  const [editingFolder, setEditingFolder] = useState(null);
  const [editName, setEditName] = useState('');

  const handleCreate = () => {
    if (newFolderName.trim()) {
      onCreateFolder({ name: newFolderName.trim() });
      setNewFolderName('');
      setIsCreating(false);
    }
  };

  const handleEdit = (folder) => {
    setEditingFolder(folder.id);
    setEditName(folder.name);
  };

  const handleSaveEdit = (folderId) => {
    if (editName.trim()) {
      onUpdateFolder(folderId, { name: editName.trim() });
      setEditingFolder(null);
    }
  };

  return (
    <div className={`folder-sidebar ${embedded ? 'embedded' : ''}`}>
      <div className="folder-header">
        <h3>{isGerman ? 'Ordner' : 'Folders'}</h3>
        <Button 
          onClick={() => setIsCreating(true)}
          variant="outline"
          size="sm"
          className="create-folder-btn"
        >
          +
        </Button>
      </div>

      {isCreating && (
        <div className="folder-create">
          <Input
            value={newFolderName}
            onChange={(e) => setNewFolderName(e.target.value)}
            placeholder={isGerman ? 'Ordnername' : 'Folder name'}
            onKeyPress={(e) => e.key === 'Enter' && handleCreate()}
            autoFocus
          />
          <div className="folder-actions">
            <Button onClick={handleCreate} size="sm">✓</Button>
            <Button onClick={() => { setIsCreating(false); setNewFolderName(''); }} size="sm" variant="outline">✕</Button>
          </div>
        </div>
      )}

      <div className="folder-list">
        {/* All Stories */}
        <div 
          className={`folder-item ${selectedFolder === null ? 'active' : ''}`}
          onClick={() => onSelectFolder(null)}
        >
          <span className="folder-icon folder-icon-library" aria-hidden="true"></span>
          <span className="folder-name">{isGerman ? 'Alle Geschichten' : 'All Stories'}</span>
          <span className="folder-count">{storyCounts.all || 0}</span>
        </div>

        {/* Favorites */}
        <div 
          className={`folder-item ${selectedFolder === 'favorites' ? 'active' : ''}`}
          onClick={() => onSelectFolder('favorites')}
        >
          <span className="folder-icon folder-icon-favorite" aria-hidden="true"></span>
          <span className="folder-name">{isGerman ? 'Favoriten' : 'Favorites'}</span>
          <span className="folder-count">{favoriteCount || 0}</span>
        </div>

        {/* User Folders */}
        <div className="folder-divider"></div>
        {folders.map((folder) => (
          <div 
            key={folder.id}
            className={`folder-item ${selectedFolder === folder.id ? 'active' : ''}`}
          >
            {editingFolder === folder.id ? (
              <div className="folder-edit">
                <Input
                  value={editName}
                  onChange={(e) => setEditName(e.target.value)}
                  onKeyPress={(e) => e.key === 'Enter' && handleSaveEdit(folder.id)}
                  size="sm"
                  autoFocus
                />
                <Button onClick={() => handleSaveEdit(folder.id)} size="sm">✓</Button>
                <Button onClick={() => setEditingFolder(null)} size="sm" variant="outline">✕</Button>
              </div>
            ) : (
              <>
                <div className="folder-main" onClick={() => onSelectFolder(folder.id)}>
                  <span className="folder-color" style={{ backgroundColor: folder.color }}></span>
                  <span className="folder-name">{folder.name}</span>
                  <span className="folder-count">{storyCounts[folder.id] || 0}</span>
                </div>
                <div className="folder-menu">
                  <button onClick={(e) => { e.stopPropagation(); handleEdit(folder); }}>✏️</button>
                  <button onClick={(e) => { e.stopPropagation(); onDeleteFolder(folder.id); }}>🗑️</button>
                </div>
              </>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default FolderSidebar;
